<!--
  - Copyright (c) 2022.
  -
  - Unless required by applicable law or agreed to in writing, software
  - distributed under the License is distributed on an "AS IS" BASIS,
  - WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  - See the License for the specific language governing permissions and
  - limitations under the License.
  -
  -->

<template>
    <div>
        <van-nav-bar
            :title="address.id?'修改收货地址':'添加收货地址'"
            left-arrow
            @click-left="$router.go(-1)"
        />


        <van-address-edit
            :area-list="areaList"
            :address-info="address"
            :show-delete="address.id>0"
            show-set-default
            show-search-result
            :area-columns-placeholder="['请选择', '请选择', '请选择']"
            @save="onSave"
            @delete="onDelete"
        />
    </div>
</template>

<script>
import http from "@/utils/http";
import qs from "qs";
import {Notify} from "vant";

export default {
    data() {
        return {
            loading: false,
            areaList:{},
            address: {id: 0}
        };
    },
    created() {
        var id = this.$route.query.id?this.$route.query.id:'';
        if(!id) {
            id = '0';
        }
        var idInt = parseInt(id);
        var address = {id: 0};
        if(idInt) {
            var addressString = localStorage.getItem('my_address_edit');
            if(addressString) {
                address = JSON.parse(addressString);
                if(address && address.id === idInt) {
                    address.addressDetail = address.address2?address.address2:address.address;
                    // console.log(address)
                }
            }
        }
        this.loadAreaList(()=> {
            this.address = address;
        });
    },
    methods: {
        onSave(content) {
            var payload = {
                id: this.address.id,
                name: content.name,
                defaultAddress: content.isDefault,
                mobile: content.tel,
                addressCode: content.areaCode,
                address: content.addressDetail
            }
            this.loading = true;
            http.post('/api/personal/save_address', qs.stringify(payload)).then(res => {
                this.loading = false;
                if (!res.data.result) {
                    Notify({type: 'danger', message: res.data.message});
                } else {
                    Notify({type: 'success', message: res.data.message});
                    this.$router.go(-1);
                }
            }).catch(()=>this.loading = false);
        },
        onDelete() {
            this.loading = true;
            http.get('/api/personal/delete_address?id='+this.address.id).then(res => {
                this.loading = false;
                if (!res.data.result) {
                    Notify({type: 'danger', message: res.data.message});
                } else {
                    Notify({type: 'success', message: res.data.message});
                    this.$router.go(-1);
                }
            }).catch(()=>this.loading = false);
        },
        loadAreaList(callback) {
            http.get('/api/public/area_list').then(res => {
                this.areaList = res.data;
                callback();
            });
        },
    },
}
</script>

<style scoped>
/deep/.van-address-edit__buttons .van-button--danger {
    background-color: var(--color);
    border-color: unset;
}
/deep/ .van-switch--on {
    background-color: var(--color);
}
</style>